/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { JWTHeaderParameters } from "jose";

import { ForgeCryptoProvider } from "./ForgeCryptoProvider";
import { WebCryptoProvider } from "./WebCryptoProvider";

export type TWebCryptoKeyPair = {
  publicKey: JsonWebKey;
  privateKey: JsonWebKey;
};

export type TForgeCryptoKeyPair = {
  publicKey: string;
  privateKey: string;
};

export type CryptoKeyPair = TWebCryptoKeyPair | TForgeCryptoKeyPair;

export type CryptoPrivateKey = JsonWebKey | string;

export type CryptoPublicKey = JsonWebKey | string;

export type CryptoProvider =
  | typeof WebCryptoProvider
  | typeof ForgeCryptoProvider;

export type JwtHeader =
  | JWTHeaderParameters
  | {
      [key: string]: string;
    };

export type JwtClaims = {
  [key: string]: unknown;
};
